module.exports = __webpack_public_path__ + "static/sport/bgi-h5.0f3acd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-h5.jpg
// module id = +7KZ
// module chunks = 0